import { useEffect, useRef } from 'react';
import useMarkStepDone from '../hooks/useMarkStepDone';

export default function OnboardingChecker() {
  const { checkCurrentStep } = useMarkStepDone();
  const hasChecked = useRef(false);

  useEffect(() => {
    if (hasChecked.current) return;
    hasChecked.current = true;
    checkCurrentStep();
  }, [checkCurrentStep]);

  return <></>;
}
